import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import {
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../../utils/apiUtils";
import { toast } from "react-toastify";
import TableSkeleton from "../../components/TableSkeleton";
import TableAirbnb from "../../components/TableAirbnb";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import CircularProgress from "@mui/material/CircularProgress";

const SyncAll = ({ value, hotelId }) => {
  const [loader, setLoader] = useState(false);
  const handleButton = () => {
    setLoader(true);
    handleSpringDataRequest(`cm/api/airbnb/syncall/?listing_id=${value}&hotelId=${hotelId}`)
      .then((elm) => {
        toast.success(elm);
        setLoader(false);
      })
      .catch((err) => {
        toast.error("Something went wrong");
        setLoader(false);
      });
  };
  return (
    <Button
      variant="custom-button"
      sx={{ height: "1.8rem" }}
      onClick={handleButton}
    >
      {loader ? <CircularProgress size={24} /> : "Sync All"}
    </Button>
  );
};

const SyncRatesAndAvailability = ({ value , hotelId}) => {
  const [loader, setLoader] = useState(false);
  const handleButton = () => {
    setLoader(true);
    handleSpringDataRequest(`cm/api/airbnb/syncratesavail/?listing_id=${value}&hotelId=${hotelId}`)
      .then((elm) => {
        toast.success(elm);
        setLoader(false);
      })
      .catch((err) => {
        toast.error("Something went wrong");
        setLoader(false);
      });
  };
  return (
    <Button
      variant="custom-button"
      sx={{ height: "1.8rem" }}
      onClick={handleButton}
    >
      {loader ? <CircularProgress size={24} /> : "Sync Rates And Availability"}
    </Button>
  );
};

const SetHashAvailability = ({ value, hotelId }) => {
  const [loader, setLoader] = useState(false);
  const handleButton = () => {
    setLoader(true);
    handleSpringDataRequest(`cm/api/airbnb/hasavail/?listing_id=${value}&hotelId=${hotelId}`)
      .then((elm) => {
        toast.success(elm);
        setLoader(false);
      })
      .catch((err) => {
        toast.error("Something went wrong");
        setLoader(false);
      });
  };
  return (
    <Button
      variant="custom-button"
      sx={{ height: "1.8rem" }}
      onClick={handleButton}
    >
      {loader ? <CircularProgress size={24} /> : <CheckIcon />}
    </Button>
  );
};

const SetHashNoAvailability = ({ value, hotelId }) => {
  const [loader, setLoader] = useState(false);
  const handleButton = () => {
    setLoader(true);
    handleSpringDataRequest(`cm/api/airbnb/hasnoavail/?listing_id=${value}&hotelId=${hotelId}`)
      .then((elm) => {
        toast.success(elm);
        setLoader(false);
      })
      .catch((err) => {
        toast.error("Something went wrong");
        setLoader(false);
      });
  };
  return (
    <Button
      variant="outlined"
      sx={{
        background: "rgba(255, 0, 0, 0.6)",
        color: "white",
        height: "1.8rem",
        "&:hover": {
          background: "rgba(255, 0, 0, 0.7)",
        },
      }}
      onClick={handleButton}
    >
      {loader ? <CircularProgress size={24} /> : <CloseIcon />}
    </Button>
  );
};
const ReadyForReview = ({ value , hotelId}) => {
  const [loader, setLoader] = useState(false);
  const handleButton = () => {
    setLoader(true);
    handleSpringDataRequest(`cm/api/airbnb/reqapproval/?listing_id=${value}&hotelId=${hotelId}`)
      .then((elm) => {
        toast.success(elm);
        setLoader(false);
      })
      .catch((err) => {
        toast.error("Something went wrong");
        setLoader(false);
      });
  };
  return (
    <Button
      variant="custom-button"
      sx={{ height: "1.8rem" }}
      onClick={handleButton}
    >
      {loader ? <CircularProgress size={24} /> : "Ready For Review"}
    </Button>
  );
};

export default function AirBnb({ hotelId }) {
  const [rowData, setRowData] = useState();
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "listing",
      headerName: "Listing",
      floatingFilter: true,
      width: 140,
    },
    {
      field: "listing",
      headerName: "Sync All",
      cellRenderer: SyncAll,
      cellRendererParams: { hotelId },
      width: 170,
    },
    {
      field: "listing",
      headerName: "Sync Rates And Availability",
      cellRenderer: SyncRatesAndAvailability,
      cellRendererParams: { hotelId },
      minWidth: 300,
    },
    {
      field: "listing",
      headerName: "Set Hash Availability",
      cellRenderer: SetHashAvailability,
      cellRendererParams: { hotelId },
      width: 170,
    },
    {
      field: "listing",
      headerName: "Set Hash No Availability",
      cellRenderer: SetHashNoAvailability,
      cellRendererParams: { hotelId },
      width: 185,
    },
    {
      field: "listing",
      headerName: "Ready For Review",
      cellRenderer: ReadyForReview,
      cellRendererParams: { hotelId },
      minWidth: 200,
    },
  ]);
  //---------Handeling Row Data---------------
  const handleRowData = (data) => {
    const myData = [];
    data.map((elm) => {
      myData.push({ listing: elm });
    });
    console.log(myData);
    setRowData(myData);
  };

  //---------------Skeleton--------
  const [table, setTable] = useState(false);
  useEffect(() => {
    setTable(false);
    handleSpringDataRequest(
      `core/api/v1/cm/get-airbnb-listing?hotelId=${hotelId}`
    )
      .then((data) => {
        setTable(true);
        handleRowData(data);
      })
      .catch((err) => setTable(true));
  }, []);

  //---------------Host Input and List Input---------------
  const [authCode, setAuthCode] = useState();
  const [hostId, setHostId] = useState();

  const handleAuthCode = () => {
    setLoaderAuth(true);
    handleSpringDataRequest(
      `core/api/v1/cm/create-token-for-airbnb?authCode=${authCode}&hotelId=${hotelId}`
    )
      .then(() => {
        toast.success("Auth Code Successfully Set");
        setLoaderAuth(false);
      })
      .catch(() => {
        toast.error("Something went wrong");
        setLoaderAuth(false);
      });
  };
  const handleHostId = () => {
    setLoaderListing(true);
    handleSpringDataRequest(
      `core/api/v1/cm/create-listing-for-airbnb?hotelId=${hotelId}&hostId=${hostId}`
    )
      .then(() => {
        toast.success("Host Id Successfully Set");
        setLoaderListing(false);
      })
      .catch(() => {
        toast.error("Something went wrong");
        setLoaderListing(false);
      });
  };
  //---------Loaders----------
  const [loaderAuth, setLoaderAuth] = useState(false);
  const [loaderListing, setLoaderListing] = useState(false);
  const [guestPayoutEnabled, setGuestPayoutEnabled] = useState(null);
  const [taxExemptEnabled, setTaxExemptEnabled] = useState(null);
  const [guestPayoutLoader, setGuestPayoutLoader] = useState(false);
  const [taxExemptLoader, setTaxExemptLoader] = useState(false);
  const [airbnbConfigFetchLoader, setAirbnbConfigFetchLoader] = useState(false);

  const normalizeEnabledStatus = (data) => {
    if (data == null) {
      return false;
    }
    if (typeof data === "string") {
      return data.toLowerCase() === "yes";
    }
    if (typeof data === "boolean") {
      return data;
    }
    if (typeof data === "number") {
      return data === 1;
    }
    if (data && typeof data === "object") {
      if ("data" in data && data.data !== undefined) {
        return normalizeEnabledStatus(data.data);
      }
      if (typeof data.enabled === "string") {
        return data.enabled.toLowerCase() === "yes";
      }
      if (typeof data.enabled === "boolean") {
        return data.enabled;
      }
      if (typeof data.status === "string") {
        const s = data.status.toLowerCase();
        if (s === "yes" || s === "no") {
          return s === "yes";
        }
      }
    }
    return false;
  };

  const fetchGuestPayoutStatus = () =>
    handleSpringDataRequest(
      `core/api/v1/airbnb/guest-payout/get?hotelId=${hotelId}`
    )
      .then((data) => {
        setGuestPayoutEnabled(normalizeEnabledStatus(data));
      })
      .catch(() => {
        setGuestPayoutEnabled(false);
      });

  const fetchTaxExemptStatus = () =>
    handleSpringDataRequest(
      `core/api/v1/airbnb/tax-exempt/get?hotelId=${hotelId}`
    )
      .then((data) => {
        setTaxExemptEnabled(normalizeEnabledStatus(data));
      })
      .catch(() => {
        setTaxExemptEnabled(false);
      });

  const refreshAirbnbConfigFromServer = () => {
    setAirbnbConfigFetchLoader(true);
    setGuestPayoutEnabled(null);
    setTaxExemptEnabled(null);
    Promise.all([fetchGuestPayoutStatus(), fetchTaxExemptStatus()]).finally(
      () => {
        setAirbnbConfigFetchLoader(false);
      }
    );
  };

  const toggleGuestPayout = () => {
    const nextStatus = guestPayoutEnabled ? "no" : "yes";
    setGuestPayoutLoader(true);
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/airbnb/guest-payout/add?hotelId=${hotelId}&enabled=${nextStatus}`
    )
      .then(() => {
        setGuestPayoutEnabled(nextStatus === "yes");
        fetchGuestPayoutStatus();
        toast.success(
          `Guest payout ${nextStatus === "yes" ? "enabled" : "disabled"} successfully`
        );
      })
      .catch(() => {
        toast.error("Failed to update guest payout");
      })
      .finally(() => {
        setGuestPayoutLoader(false);
      });
  };

  const toggleTaxExempt = () => {
    const nextStatus = taxExemptEnabled ? "no" : "yes";
    setTaxExemptLoader(true);
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/airbnb/tax-exempt/add?hotelId=${hotelId}&enabled=${nextStatus}`
    )
      .then(() => {
        setTaxExemptEnabled(nextStatus === "yes");
        fetchTaxExemptStatus();
        toast.success(
          `Tax exempt ${nextStatus === "yes" ? "enabled" : "disabled"} successfully`
        );
      })
      .catch(() => {
        toast.error("Failed to update tax exempt");
      })
      .finally(() => {
        setTaxExemptLoader(false);
      });
  };

  useEffect(() => {
    refreshAirbnbConfigFromServer();
  }, [hotelId]);

  return (
    <>
      <Grid item xs={12} sx={{ boxShadow: 8 }}>
        <Card sx={{ marginBottom: 2 }}>
          <CardHeader
            title={"Authenticate The Code"}
            subheader={"Authenticate The Code From Airbnb"}
          >
            <Divider />
          </CardHeader>
          <Divider />
          <CardContent>
            <TextField
              size="small"
              id="outlined-basic"
              label="AuthCode"
              variant="outlined"
              value={authCode}
              onChange={(e) => setAuthCode(e.target.value)}
            />
            <Button
              variant="custom-button"
              sx={{ ml: 2 }}
              onClick={handleAuthCode}
            >
              {loaderAuth ? <CircularProgress size={24} /> : "Submit"}
            </Button>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sx={{ boxShadow: 8 }}>
        <Card sx={{ marginBottom: 2 }}>
          <CardHeader title={"Create Listing"} subheader={"Create Listing"}>
            <Divider />
          </CardHeader>
          <Divider />
          <CardContent>
            <TextField
              size="small"
              id="outlined-basic"
              label="Host ID"
              variant="outlined"
              value={hostId}
              onChange={(e) => setHostId(e.target.value)}
            />
            <Button
              variant="custom-button"
              sx={{ ml: 2 }}
              onClick={handleHostId}
            >
              {loaderListing ? <CircularProgress size={24} /> : "Submit"}
            </Button>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sx={{ boxShadow: 8 }}>
        <Card sx={{ marginBottom: 2 }}>
          <CardHeader
            title={"Airbnb Listing Settings"}
            subheader={
              "Guest payout and tax exempt (loaded via GET tax-exempt/get and guest-payout/get)"
            }
            action={
              <Button
                size="small"
                variant="outlined"
                onClick={refreshAirbnbConfigFromServer}
                disabled={airbnbConfigFetchLoader}
              >
                {airbnbConfigFetchLoader ? (
                  <CircularProgress size={18} />
                ) : (
                  "Refresh status"
                )}
              </Button>
            }
          >
            <Divider />
          </CardHeader>
          <Divider />
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 1,
                mb: 1,
              }}
            >
              <Typography>
                Guest Payout:{" "}
                <strong>
                  {guestPayoutEnabled === null
                    ? "Loading…"
                    : guestPayoutEnabled
                    ? "Enabled"
                    : "Disabled"}
                </strong>
              </Typography>
              <Button
                variant="custom-button"
                onClick={toggleGuestPayout}
                disabled={
                  guestPayoutLoader ||
                  guestPayoutEnabled === null ||
                  airbnbConfigFetchLoader
                }
              >
                {guestPayoutLoader ? (
                  <CircularProgress size={20} />
                ) : guestPayoutEnabled ? (
                  "Disable"
                ) : (
                  "Enable"
                )}
              </Button>
            </Box>
            <Divider sx={{ my: 2 }} />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <Typography>
                Tax Exempt:{" "}
                <strong>
                  {taxExemptEnabled === null
                    ? "Loading…"
                    : taxExemptEnabled
                    ? "Enabled"
                    : "Disabled"}
                </strong>
              </Typography>
              <Button
                variant="custom-button"
                onClick={toggleTaxExempt}
                disabled={
                  taxExemptLoader ||
                  taxExemptEnabled === null ||
                  airbnbConfigFetchLoader
                }
              >
                {taxExemptLoader ? (
                  <CircularProgress size={20} />
                ) : taxExemptEnabled ? (
                  "Disable"
                ) : (
                  "Enable"
                )}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Box>
        {table ? (
          rowData ? (
            <TableAirbnb rowData={rowData} columnDefs={columnDefs} />
          ) : (
            <Box
              sx={{
                position: "absolute",
                transform: "translate(-50%, -50%)",
                top: "80%",
                left: "50%",
              }}
            >
              <Typography>No Data Found.......</Typography>
            </Box>
          )
        ) : (
          <TableSkeleton />
        )}
      </Box>
    </>
  );
}
